import ClientIdType from 'owa-service/lib/contract/ClientIdType';
import EntityType from 'owa-service/lib/contract/EntityType';
import store from 'owa-feedback-manager-store/lib/store/locationFeedbackManagerStore';
import { action } from 'satcheljs/lib/legacy';

/**
 * Initialize the LocationFeedbackManager store
 */
export default action('initializeLocationFeedbackManagerState')(
    function initializeLocationFeedbackManagerState() {
        store.feedbackManagerState = {
            maxActionBatchSize: 10,
            entityType: EntityType.CalendarLocation,
            entityScenarioName: 'LocationWell_react',
            hasSessionStarted: false,
            isSessionPaused: false,
            entityFeedbackEntries: [],
            clientSessionId: '',
            clientVersion: '1.1',
            clientId: ClientIdType.Web,
            entrySequenceNumber: 0,
        };
    }
);
